<div
  class="vh-100 vw-100 position-fixed top-0 start-0 bg-primary text-white d-flex flex-column justify-content-center align-items-center"
  style="z-index: 9999"
>
  <img
    src="assets/img/cooxupe-simbol.svg"
    alt="Cooxupé"
    style="width: 150px; height: auto"
  />
  <p class="lead mt-3">Página não encontrada</p>

  <app-action-button
    [label]="'Voltar ao Início'"
    [iconClass]="'bi bi-house'"
    [variant]="'light'"
    [route]="'/dashboard'"
    class="mt-3"
  />
</div>
